import script from "./DoctorFiles.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorFiles.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorFiles.vue?vue&type=style&index=0&id=15ce73e2&lang=scss"

const __exports__ = script;

export default __exports__